import {isDefined} from "@/utils";
import {Speech} from "@/entities/Speech";

export class SpeechContainer {

  private _speechMap: Record<string, Speech[]> = {};
  private readonly _speeches: Speech[] = [];

  constructor(entities: Speech[]) {
    this.createSpeechMap(entities);
    this._speeches = entities;
  }

  private createSpeechMap(entities: Speech[]): void {
    this._speechMap = {}
    for (const speech of entities) {
      let date = speech.startDate;
      if (!isDefined(this._speechMap[date])) {
        this._speechMap[date] = [];
      }
      this._speechMap[date].push(speech);
    }
  }

  public getSpeechMap(): Record<string, Speech[]> {
   return this._speechMap;
  }

  public hasMorePages(pageSize): boolean {
    return this._speechMap.length > pageSize;
  }

  public filterSpeeches(searchValue: string, filters: Record<string, string>): void {
    let filteredExhibitors: Speech[];
    searchValue = searchValue.trim().toLowerCase();
    if (searchValue.length > 0) {
      filteredExhibitors = this.applyFilters(filters, this._speeches);
      filteredExhibitors = filteredExhibitors.filter(e => {
        return e.hasSearchValue(searchValue);
      });
      filteredExhibitors = this.applyFilters(filters, filteredExhibitors);
    } else {
      filteredExhibitors = this.applyFilters(filters, this._speeches);
    }
    this.createSpeechMap(filteredExhibitors);
  }

  private applyFilters(filters: Record<string, string>, speeches: Speech[]): Speech[] {
    if (isDefined(filters) && Object.entries(filters).length > 0) {
      for (const [key, value] of Object.entries(filters)) {
        speeches = speeches.filter(e => {
          if (isDefined(e.themes)) {
            return e.themes.indexOf(value) > -1;
          }
          return false;
        });
      }
    }
    return speeches;
  }

  public hasEntries(): boolean {
    return JSON.stringify(this._speechMap) !== JSON.stringify({});
  }


  get speeches(): Speech[] {
    return this._speeches;
  }

  getSpeechesForSpeakerById(speakerId):Speech[]{
    if(!isDefined(this._speeches) || this._speeches.length === 0){
      return  [];
    }
    return this._speeches.filter(s => s.persons.find(e => e.id === speakerId));
  }
}
